import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { LaundryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddLaundryForm from "./Componates/AddLaundryForm";
import fields from "../json/LaundryFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { validateItems } from "../Helper/validateItems";
import {
    Create,
    GetAllProduct,
    GetAllEmployees,
    GetAllTask,
} from "adminApi/LaundryApi/Laundry.js";

/**
 * AddLaundry — smart container for creating a new laundry record.
 * Owns all state, API calls, and validation.
 * Passes data + callbacks to AddLaundryForm (presentational).
 */
const AddLaundry = () => {
    const navigate = useNavigate();
    const { formdata, item } = fields;

    // Include "items" in initial values so the form can sync the item rows
    const initialValues = useMemo(() => {
        const base = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});
        return { ...base, items: [{ product_id: "", task_id: [], quantity: "", totle: 0 }] };
    }, [formdata]);

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        LaundryRules
    );

    // Dropdown data
    const { data: ProductOptions = [] } = useFetchAllData(GetAllProduct);
    const { data: EmployeesOptions = [] } = useFetchAllData(GetAllEmployees);
    const { data: TaskOptions = [] } = useFetchAllData(GetAllTask);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                // items array must be JSON-stringified for FormData
                formData.append(key, key === "items" ? JSON.stringify(val) : (val ?? ""));
            });
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryRules);
            const itemErrors = validateItems(vals.items);
            if (itemErrors) err.items = itemErrors;
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry created successfully."
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner />}
            <AddLaundryForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                item={item}
                ProductOptions={ProductOptions}
                EmployeesOptions={EmployeesOptions}
                TaskOptions={TaskOptions}
                setValues={setValues}
                validateItems={validateItems}
                setErrors={setErrors}
            />
        </>
    );
};

export default AddLaundry;
